import { useEffect } from 'react';

/**
 * Syncs document.title with the given string (typically the page header title).
 * Updates only when the title changes — no restore on unmount.
 */
export function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return;
    document.title = title;
  }, [title]);
}
